import { PageUsers } from "@components/modules/users/listing/PageUsers";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { NavigationUsers } from "@src/components/widgets/AppSubNav/NavigationUsers/NavigationUsers";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => (
  <MainLayout title={t`Users`} navigation={<NavigationUsers />}>
    <PageUsers userType="client" />
  </MainLayout>
);

export const Route = createFileRoute("/users/client-access/")({
  component: Page,
});
